// @flow
import React, { Component } from 'react'
import Axios from 'axios'
import { Row, Col } from 'antd'
import { StyledCol } from './style'

type Props = {
  symbol: string
}

type State = {
  data: Object,
  newsLatters: Object[],
  error: null | string,
  isLoading: boolean
}

class Profile extends Component<Props, State> {

  state: State = {
    data: {},
    newsLatters: [],
    error: null,
    isLoading: true
  }

  componentDidMount() {

    this.getProfileData()
  }

  getProfileData = async () => {

    const { symbol } = this.props

    try {

      const promises = ['company','quote', 'stats'].map(x=>Axios.get(`https://cloud.iexapis.com/v1/stock/${symbol}/${x}?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`))
      const responses =  await Promise.all(promises);
      let data = {}
      responses.forEach(response=> {
        if (response.status === 200) {
          data = {
            ...data,
            ...response.data
          }
        }
      })
      this.setState({
        data,
        isLoading: false
      })

    } catch (err) {

      this.setState({
        error: 'something went wrong',
        isLoading: false
      })
    }
  }

  render() {

    const { isLoading, description, website, sector, industry, exchange, week52High, week52Low, marketCap, close,
      open, beta, latestEPS, latestEPSDate, float, sharesOutstanding, dividendYield, exDividendDate, peRatio,
      avgTotalVolume, tags = [] } = this.state.data || {}

    if (isLoading) return <div>Loading...</div>

    return (
      <Row>
        <Col sm={12}>
          <p>{description}</p>
          <Col className='d-flex flex-wrap'>
            <StyledCol sm={12} xs={24}>
              <h6>Exchange</h6>
              <p>{exchange}</p>
            </StyledCol>
            <StyledCol sm={12} xs={24}>
              <h6>Number of employees</h6>
              <p>~122,999</p>
            </StyledCol>
            <StyledCol sm={12} xs={24}>
              <h6>Float</h6>
              <p>{float}</p>
            </StyledCol>
            <StyledCol sm={12} xs={24}>
              <h6>Shares outstanding</h6>
              <p>{sharesOutstanding}</p>
            </StyledCol>
            <StyledCol sm={12} xs={24}>
              <h6>Sector</h6>
              <p>{sector}</p>
            </StyledCol>
            <StyledCol sm={12} xs={24}>
              <h6>Industry</h6>
              <p>{industry}</p>
            </StyledCol>
            <StyledCol sm={24} xs={24}>
              <h6>Website</h6>
              <a href='http://www.apple.com'
                className='break-word'
                target='_blank'
                rel='noopener noreferrer'>

                <p className='mb0 bold small-text mt0'>{website}</p>
              </a>
            </StyledCol>
            <StyledCol sm={24} xs={24}>
              <h6>Tags</h6>
              {
                tags.map(tag=>(
                  <span className='inline-block'>
                    {tag},&nbsp;
                  </span>
                ))
              }
            </StyledCol>
          </Col>
        </Col>
        <Col sm={12}>
          <div className='d-flex flex-wrap'>
            <StyledCol sm={8} xs={24}>
              <h6>Volume</h6>
              <p>625,349</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Avg daily volume</h6>
              <p>{avgTotalVolume}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Open</h6>
              <p>${open}</p>
            </StyledCol>

            <StyledCol sm={8} xs={24}>
              <h6>52 week range</h6>
              <p>{week52Low} - {week52High}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Market cap</h6>
              <p>{marketCap}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Previous close</h6>
              <p>{close}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Beta</h6>
              <p>{beta}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Latest EPS</h6>
              <p>{latestEPS}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Latest EPS date</h6>
              <p>{latestEPSDate}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
              <h6>Dividend &amp;yield</h6>
              <p>{dividendYield}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
                <h6>Ex-dividend date</h6>
                <p>{exDividendDate}</p>
            </StyledCol>
            <StyledCol sm={8} xs={24}>
                <h6>P/E ratio</h6>
                <p>{peRatio}</p>
            </StyledCol>
          </div>
        </Col>
      </Row>
    )
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/components/view-profile/index.js